module.exports = __webpack_public_path__ + "img/sv8.0de767a0.svg";